import Image from 'next/image';

import { KeyValueRow, KeyValueTable } from '@/design-system/components/ui';

import { Trigger } from '../../domain';
import { AddressChip } from './components/AddressChip';

interface Props {
  trigger: Trigger;
}

export const SuiTokenHoldersTriggerFullDetails = ({ trigger }: Props) => {
  const tokenAddress = trigger.signature.replace('SUI-TokenHolders-', '');

  const contractDisplay = (
    <div className="tw:flex tw:flex-row tw:gap-2 tw:items-center">
      <AddressChip
        address={tokenAddress}
        scannerUrl={`https://suiscan.xyz/mainnet/coin/${tokenAddress}`}
        hideChainIcon
      />
    </div>
  );

  const networkDisplay = (
    <div className="tw:flex tw:flex-row tw:items-center tw:gap-2">
      <Image src="/assets/webp/sui.webp" alt="SUI" width={20} height={20} />
      <span>SUI</span>
    </div>
  );

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Executed with" value="Snapshots of SUI token holders for contract">
        <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center tw:flex-wrap tw:ml-2">{contractDisplay}</div>
      </KeyValueRow>
      <KeyValueRow label="Network" value={networkDisplay} />
      <KeyValueRow label="Argument conditions" value={trigger.conditionExpression ?? '-'} />
    </KeyValueTable>
  );
};
